/* RESPONSIBLE TEAM: team-frontend-tech */

/*
 * ⚠️  WARNING: BRIDGE LOGIC - DO NOT MODIFY WITHOUT #team-frontend-tech APPROVAL ⚠️
 *
 * This file contains critical bridge logic that enables communication between the
 * Ember app (apps/embercom) and React app (apps/teammate-app). Any modifications
 * to this file can break the integration between the two applications.
 *
 * Before making any changes to this file, please reach out to #team-frontend-tech
 * for review and approval.
 */

import ENV from 'embercom/config/environment';

export function getViteBaseUrl(hostname = window.location.hostname): string {
  if (hostname.endsWith('.intercom.test')) {
    let prefix = hostname.replace('.intercom.test', '');
    if (prefix !== 'app' && prefix !== 'intercomrades') {
      return `http://${prefix}.teammate-app.test/r`;
    }
  }
  return 'http://localhost:5173/r';
}

export function getVersionFromMetaTag(): string | null {
  let metaTag = document.querySelector('meta[name="teammate_app_revision_version"]');
  return metaTag ? metaTag.getAttribute('content') : null;
}

export function getActiveRevisionFromMetaTag() {
  let metaTag = document.querySelector('meta[name="teammate_app_active_revision_version"]');
  return metaTag ? metaTag.getAttribute('content') : null;
}

export function getTeammateAppUrls() {
  let urls = ENV.APP.teammateAppIsland;

  let metaTagVersion = getVersionFromMetaTag();
  if (metaTagVersion) {
    if (metaTagVersion.endsWith('-experimental')) {
      if (urls.experimental) {
        return {
          jsUrl: urls.experimental.js.replace('{experimental-branch}', metaTagVersion),
          cssUrl: urls.experimental.css.replace('{experimental-branch}', metaTagVersion),
        };
      }
    } else if (urls.versioned) {
      return {
        jsUrl: urls.versioned.js.replace('{hash}', metaTagVersion),
        cssUrl: urls.versioned.css.replace('{hash}', metaTagVersion),
      };
    }
  }

  if (urls.development) {
    let viteBaseUrl = getViteBaseUrl();
    return {
      jsUrl: `${viteBaseUrl}/src/app/entry-island.tsx`,
      cssUrl: `${viteBaseUrl}/src/index.css`,
    };
  }

  throw new Error('No teammate app URLs available');
}

export async function validateExperimentalUrls(jsUrl: string, cssUrl: string): Promise<boolean> {
  try {
    let [jsResponse, cssResponse] = await Promise.all([
      fetch(jsUrl, { method: 'HEAD' }),
      fetch(cssUrl, { method: 'HEAD' }),
    ]);
    return jsResponse.ok && cssResponse.ok;
  } catch (error) {
    return false;
  }
}
